// extracted by mini-css-extract-plugin
export var bodySections = "_e7-8";
export var gray = "_e7-7";
export var green = "_e7-4";
export var iconContainer = "_e7-9";
export var iconWidgetContainer = "_e7-1";
export var phoneIcon = "_e7-2";
export var red = "_e7-5";
export var statusDot = "_e7-3";
export var widgetContainer = "_e7-0";
export var yellow = "_e7-6";